import script from "./CreateSelfResponse.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateSelfResponse.vue?vue&type=script&setup=true&lang=ts"

import "./CreateSelfResponse.vue?vue&type=style&index=0&id=28b41bdd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b41bdd"]])

export default __exports__